import { useGetAllMySuppliers } from '@/api/supplier.api';
import ViewCarRentalForm from '@/components/carRental/ViewCarRentalForm';
import Loader from '@/components/ui/Loader';
import { useGetCarRental } from '@/hooks/useCarRental';
import { useResourceLanguage } from '@/hooks/useResourceLanguage';
import { memo } from 'react';
import { useParams } from 'react-router';

const ViewCarRentalFormMemo = memo(ViewCarRentalForm);

const ViewCarRentalPage = () => {
  const { benefitId = '' } = useParams();

  const { language, setLanguage } = useResourceLanguage();

  const { data: carRental, isLoading, isSuccess } = useGetCarRental(benefitId);
  const { data: suppliers } = useGetAllMySuppliers();

  return isLoading ? (
    <Loader />
  ) : (
    isSuccess && (
      <ViewCarRentalFormMemo
        carRental={carRental}
        suppliers={suppliers}
        language={language}
        setLanguage={setLanguage}
        key={`car-rental-${carRental.id}`}
      />
    )
  );
};

export default ViewCarRentalPage;
